import { PROPERTY_INJECTED } from './rules-engine-actions';
import _ from 'lodash';

export default function (state = {}, action) {
  switch (action.type) {
    case PROPERTY_INJECTED: {
      const cloned = _.clone(state);
      for (const key in action.obj) {
        cloned[key] = action.obj[key];
      }
      return cloned;
    }
		default:
	}

  return state;
}
